"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductSkuCell = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const product_sku_cell_styles_1 = require("./product-sku-cell.styles");
const use_show_product_updated_label_hook_1 = require("../../../../../../client/product/hooks/use-show-product-updated-label.hook");
const localization_1 = require("../../../../../../../localization");
/**
 * Cell component for displaying product SKUs with update indicators.
 *
 * This component provides:
 * - Product SKU display
 * - "Updated" badge for recently modified products
 * - Compatible with both legacy and new DataGrid formats
 * - Responsive layout with proper spacing
 *
 * **Update Logic:** Shows "updated" badge based on `useShowProductUpdatedLabel` hook
 * which determines if the product was recently modified.
 *
 * **Usage:** Can be used in both old and new table systems as it doesn't depend
 * on specific table implementation details.
 *
 * @example
 * ```tsx
 * <ProductSkuCell
 *   sku="SKU-12345"
 *   updatedAt="2023-10-22T10:00:00.000Z"
 * />
 * ```
 */
const ProductSkuCell = ({ sku, updatedAt, }) => {
    const showUpdatedLabel = (0, use_show_product_updated_label_hook_1.useShowProductUpdatedLabel)(updatedAt);
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    return (react_1.default.createElement(product_sku_cell_styles_1.StyledWrapper, null, react_1.default.createElement(ui_components_1.Typography, { variant: "body2" }, sku), showUpdatedLabel && (react_1.default.createElement(product_sku_cell_styles_1.StyledUpdatedLabelWrapper, null, react_1.default.createElement(ui_components_1.Typography, { variant: "body2" }, t({ key: 'UPDATED' }))))));
};
exports.ProductSkuCell = ProductSkuCell;
